$('body').on('initScripts pageTransitionComplete', function() {
    // add missing title texts to links for SEO
    $('a').each(function () {
        let title = $(this).attr('title');

        if (typeof title === 'undefined' || title === '') {
            title = $(this).text().trim();

            $(this).attr('title', title);
        }
    });
});
